var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import sizes from './sizes';
/**
 *
 * @param {object} props
 * @param {string} [props.size='small']
 * @param {string} [props.className]
 * @param {string} [props.title]
 * @returns
 */
export default function VideoIcon(_a) {
    var { className, size = 'small', title } = _a, rest = __rest(_a, ["className", "size", "title"]);
    return (_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", className: className, viewBox: "0 0 24 24" }, rest, { children: [title && _jsx("title", { children: title }), _jsx("path", { d: "M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 00-1.94 2A29 29 0 001 11.75a29 29 0 00.46 5.33A2.78 2.78 0 003.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 001.94-2 29 29 0 00.46-5.25 29 29 0 00-.46-5.33z" }), _jsx("path", { d: "M9.75 15.02L15.5 11.75 9.75 8.48 9.75 15.02z" })] })));
}
//# sourceMappingURL=VideoIcon.js.map